import { http } from './http';

export function getMediaDetail(category, id, { language, watchRegion } = {}) {
  const params = {};
  if (language) params.language = language;
  if (watchRegion) params.watchRegion = watchRegion;
  return http.get(`/api/v1/media/${category}/${id}`, { params }).then((r) => r.data);
}

export function getMediaSeasons(category, id, { language } = {}) {
  const params = language ? { language } : undefined;
  return http.get(`/api/v1/media/${category}/${id}/seasons`, { params }).then((r) => r.data);
}
